module.exports = __webpack_public_path__ + "static/media/userIcon.223b8b51.svg";